/**
 * HTTP utilities for authenticated requests
 */

/**
 * Get authentication headers for requests
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getAuthHeaders(auth: any): Record<string, string> {
    return {
        "Content-Type": "application/json",
        ...(auth?.accessToken ? { Authorization: auth.accessToken } : {}),
    };
}

/**
 * Make an authenticated POST request with streaming support
 */
export async function makeAuthenticatedStreamRequest(
    url: string,
    payload: unknown,
    auth: unknown,
    abortController: AbortController
): Promise<Response> {
    const response = await fetch(url, {
        method: "POST",
        headers: getAuthHeaders(auth),
        body: JSON.stringify(payload),
        signal: abortController.signal,
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response;
}
